import styled from "styled-components";

export const Cell = styled.div`
    display: flex;
    align-items: center;
    font-size: 12px;
    flex-shrink: 0;
    flex-grow: 1;
`;